const options = {
    APP_NAME: process.env.VUE_APP_NAME
}

export const data = function () {
    return options
}